import { Trans } from '@lingui/macro'
import {
  Button,
  Card,
  IconButton,
  Icon,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogContent,
  Grid,
  Typography
} from '@material-ui/core'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useFormikContext } from 'formik'
import moment from 'moment'
import { opportunitieStages } from '../../../../services/sfAuth/sfData/sfOpportunity'
import { parseDisplayedText } from '../Common'
import ReactToPrint from 'react-to-print'
import { DialogTitleWithIconClose } from 'app/views/common/CustomDialog'
import { useHistory } from 'react-router'

// export const SUBMIT_GRANT_APPLICATION = 'grantApplication'
// export const SUBMIT_TECHNICAL_ADVISORY_ASSIGMENT = 'technicalAdvisoryAssigment'
// export const formSubmitTypes = [
//   {
//     id: SUBMIT_GRANT_APPLICATION,
//     label: <Trans>Grant application</Trans>,
//     object: 'Opportunity'
//   },
//   {
//     id: SUBMIT_TECHNICAL_ADVISORY_ASSIGMENT,
//     label: <Trans>Technical Advisory Assigment</Trans>,
//     object: 'TechnicalAdvisoryAssignment__c'
//   }
// ]

const GoToErrorButton = ({ error, navigateToError }) => {
  return (
    <Tooltip title={<Trans>Go to error</Trans>}>
      <IconButton
        size='small'
        style={{ marginLeft: 5, marginBottom: 5 }}
        onClick={e => {
          navigateToError({
            id: error.id,
            section: error.sectionIndex
          })
        }}
      >
        <Icon>arrow_forward</Icon>
      </IconButton>
    </Tooltip>
  )
}

export const FormErrorsList = ({
  errors = [],
  langFR,
  connectedMap,
  helperText,
  describeMap,
  objectsFieldsMap,
  navigateToError
}) => {
  if (errors.length === 0) {
    return null
  }
  const errorsToSections = {}
  errors.forEach(error => {
    if (errorsToSections[error.sectionName]) {
      errorsToSections[error.sectionName].push(error)
    } else {
      errorsToSections[error.sectionName] = [error]
    }
  })

  return (
    <Card className='p-24 mb-44 bg-light-error box-shadow-none'>
      <h5 className='m-0 mb-8 font-weight-500 text-error'>
        <Trans>Errors found!</Trans>
      </h5>
      {helperText && <p className='m-0 text-muted'>{helperText}</p>}
      {Object.keys(errorsToSections).map((key, index) => {
        const sectionErrors = errorsToSections[key]
        return (
          <div key={index} style={{ marginTop: 10 }}>
            <h6 className='m-0 mb-8 font-weight-500 text-error'>
              {parseDisplayedText({
                text: key,
                french: langFR,
                describeMap,
                objectsFieldsMap,
                renderProps: {
                  connectedMap
                }
              })}
            </h6>
            <ul>
              {sectionErrors.map((errorObj, index) => {
                const { error, title } = errorObj
                if (error && error.toMap) {
                  return (
                    <li key={index}>
                      <b>{title}</b>
                      <GoToErrorButton
                        navigateToError={navigateToError}
                        error={errorObj}
                      />
                      <ul>
                        {error.toMap.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                    </li>
                  )
                } else if (error && typeof error === 'object' && !error.props) {
                  return (
                    <div key={index}>
                      <b>{title}</b>{' '}
                      <GoToErrorButton
                        navigateToError={navigateToError}
                        error={errorObj}
                      />
                      <ul>
                        {Object.keys(error).map((key, index) => (
                          <li key={index}>
                            <u>{error[key].label}</u>: {error[key].error}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )
                } else {
                  return (
                    <li key={index}>
                      {title ? (
                        <>
                          <b>{title}:</b> {error}
                        </>
                      ) : (
                        error
                      )}
                      <GoToErrorButton
                        navigateToError={navigateToError}
                        error={errorObj}
                      />
                    </li>
                  )
                }
              })}
            </ul>
          </div>
        )
      })}
    </Card>
  )
}

export const FormSubmitButton = ({
  id,
  value,
  configuration,
  handleSubmit,
  saving,
  disabled,
  saveDisabled,
  typeProps = {},
  errors,
  objectsFieldsMap,
  connectedMap,
  navigateToError,
  printRef,
  ...props
}) => {
  const [dialogOpen, setDialogOpen] = useState(false)
  const { values } = useFormikContext()
  const history = useHistory()
  const { showPrintPromptAfterSubmit } = typeProps
  const errorsPresent = Object.keys(errors).length > 0
  let disableButton = errorsPresent || saving || disabled || saveDisabled
  if (configuration && configuration.endTime) {
    console.log('submit button', value, props)
    if (
      moment.utc().isAfter(moment(configuration.endTime).utc()) &&
      !configuration.inTesting
    ) {
      disableButton = true
      for (const connected in connectedMap) {
        const connObj = connectedMap[connected].sfObject
        if (connObj.StageName === opportunitieStages.MORE_INFO_REQUIERED) {
          disableButton = false
        }
      }
    }
  }

  return (
    <div>
      {/* TODO remove disabled when the field is configured to sav */}
      {errorsPresent && !disabled && (
        <FormErrorsList
          helperText={
            <>
              <Trans>You need to fix these error before You can submit</Trans>:
            </>
          }
          navigateToError={navigateToError}
          errors={errors}
          objectsFieldsMap={objectsFieldsMap}
          connectedMap={connectedMap}
        />
      )}
      <Dialog open={dialogOpen} maxWidth='sm' fullWidth>
        <DialogTitleWithIconClose
          label={<Trans>APPLICATION_SUBMITTED_DIALOG_TITLE</Trans>}
          handleClose={() => {
            setDialogOpen(false)
          }}
        />

        <DialogContent>
          <Typography style={{ paddingBottom: 20 }}>
            <Trans>APPLICATION_SUBMITTED_DIALOG_TEXT</Trans>
          </Typography>
          <Grid
            container
            wrap='nowrap'
            style={{ padding: 10 }}
            justifyContent='space-between'
          >
            <Grid item>
              <ReactToPrint
                trigger={() => (
                  <Button variant='contained' color='primary'>
                    <Icon style={{ marginRight: 5 }}>print</Icon>
                    <Trans>
                      APPLICATION_SUBMITTED_DIALOG_SHOW_PRINT_BUTTON
                    </Trans>
                  </Button>
                )}
                content={() => printRef.current}
              />
            </Grid>
            <Grid item>
              <Button
                variant='contained'
                color='primary'
                onClick={e => {
                  history.push('/grants/ApplicationsList')
                }}
              >
                <Icon style={{ marginRight: 5 }}>view_list</Icon>
                <Trans>
                  APPLICATION_SUBMITTED_DIALOG_SHOW_RETURN_TO_APPLICATIONS_LIST_BUTTON
                </Trans>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Button
        onClick={() => {
          handleSubmit({ values }).then(result => {
            if (showPrintPromptAfterSubmit) {
              setDialogOpen(true)
            } else {
              history.push('/grants/ApplicationsList')
            }
          })
        }}
        disabled={disableButton}
        color='primary'
        variant='contained'
        fullWidth
      >
        <Trans>Submit</Trans>
      </Button>
    </div>
  )
}

export const FormEditorSubmitButton = ({
  typeProps = {},
  depth,
  editMode,
  injectable,
  disabled,
  ...props
}) => {
  const dispatch = useDispatch()
  const { showPrintPromptAfterSubmit } = typeProps
  if (!editMode) {
    return (
      <Button color='primary' variant='contained' fullWidth>
        <Trans>Submit</Trans>
      </Button>
    )
  }

  return (
    <div>
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(showPrintPromptAfterSubmit)}
            disabled={disabled}
            onChange={e => {
              const toSet = { ...typeProps }
              toSet.showPrintPromptAfterSubmit = e.target.checked
              dispatch({
                type: 'FIELD',
                injectable,
                depth: depth.split('.'),
                fieldName: 'typeProps',
                fieldValue: toSet
              })
            }}
          />
        }
        label={<Trans>Show print prompt after submit</Trans>}
      />
    </div>
  )

  // return (
  //   <Field>
  //     {({ form }) => {
  //       const objects = form.values.objectsConnected || []
  //       const types = objects.map(obj => obj.type)
  //       const optionsAvaliable = formSubmitTypes.filter(obj =>
  //         types.includes(obj.object)
  //       )
  //       return (
  //         <TextField
  //           label={<Trans>Submit type</Trans>}
  //           select
  //           disabled={optionsAvaliable.length === 0 || !objects}
  //           value={submitType}
  //           fullWidth
  //           variant='outlined'
  //           defaultValue=''
  //           onChange={e => {
  //             const toSet = { ...typeProps }
  //             toSet.submitType = e.target.value
  //             dispatch({
  //               type: 'FIELD',
  //               depth: depth.split('.'),
  //               fieldName: 'typeProps',
  //               fieldValue: { ...toSet }
  //             })
  //           }}
  //         >
  //           {optionsAvaliable.map((item, index) => {
  //             return (
  //               <MenuItem key={index} value={item.id}>
  //                 {item.label}
  //               </MenuItem>
  //             )
  //           })}
  //         </TextField>
  //       )
  //     }}
  //   </Field>
  // )
}
